import theme from 'App.theme';
import Page from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { useLanguage } from 'context/AppContext';
import { TurnaroundSearchSurgeries } from './components/TurnaroundSearchSurgeries';
import { TurnaroundSelectEntitiesOrigin } from './components/TurnaroundSelectEntitiesOrigin';
import { TurnaroundSelectEntitiesDestination } from './components/TurnaroundSelectEntitiesDestination';
import { TurnaroundMoveEntities } from './components/TurnaroundMoveEntities';
import { TurnaroundExistingSurgeryButton } from './components/TurnaroundExistingSurgeryButton';
import { TurnaroundNewSurgeryButton } from './components/TurnaroundNewSurgeryButton';
import { TurnaroundListButton } from './components/TurnaroundListButton';
import FeatureUnavailableOverlay from 'components/FeatureUnavailableOverlay';

export const TurnaroundPage = () => {
  const lang = useLanguage()[0];

  return (
    <Page>
      <FeatureUnavailableOverlay />
      <PageHeader title={lang.Routes.Turnaround}>
        <TurnaroundListButton />

        <TurnaroundNewSurgeryButton />

        <TurnaroundExistingSurgeryButton />
      </PageHeader>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: theme.layout.spacing.medium,
        }}
      >
        <div style={{ display: 'flex', flex: 3, gap: theme.layout.spacing.medium }}>
          <TurnaroundSearchSurgeries variant="origin" style={{ flex: 1 }} />

          <TurnaroundSearchSurgeries variant="destination" style={{ flex: 1 }} />
        </div>

        <div style={{ display: 'flex', flex: 1, gap: theme.layout.spacing.medium }}>
          <TurnaroundSelectEntitiesOrigin style={{ flex: 1, overflow: 'hidden' }} />

          <TurnaroundMoveEntities />

          <TurnaroundSelectEntitiesDestination style={{ flex: 1, overflow: 'hidden' }} />
        </div>
      </div>
    </Page>
  );
};
